import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchBankMasterList = ({commit}) => {

    axios.get('/bankMaster/index.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setBankMasterList', res.data.response)         
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchBankMasterData = ({commit}, payload) => {
   
    commit('toggleLoadingState', true)
    axios.post('/bankMaster/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(payload.copy) {
            res.data.response.id = 0
            commit('displaySuccessNotification', {message: 'Data copied!!!'});
        }

        if(res.data.status) {
            
            commit('setBankMasterData', res.data.response)   
            
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetBankMasterData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitBankMasterData = ({commit}, payload) => {
        
    commit('toggleLoadingState', true)
            
    axios.post('/bankMaster/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id === 0) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteBankMasterData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/bankMaster/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchBankMasterList')
            }
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/bankMaster/actions.js